<template>
  <div>
    <!-- Desktop/Tablet Carousel -->
    <div class="carousel-container d-none d-lg-block">
      <b-carousel
        v-model="slide"
        :interval="interval"
        controls
        indicators
      >
        <b-carousel-slide v-for="(item, index) in items" :key="index">
          <template #img>
            <img
              :class="item.class || imgClass"
              :width="item.width || imgWidth"
              :height="item.height || imgHeight"
              style="object-fit: contain;"
              :src="item.img"
              :alt="`slide-${index}`"
            >
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>

    <!-- Mobile Popup -->
    <b-modal
      v-if="show"
      v-model="show"
      size="xl"
      centered
      hide-header
      hide-footer
      :no-close-on-backdrop="false"
      :no-close-on-esc="false"
      content-class="p-0 bg-transparent border-0 shadow-none"
      dialog-class="m-0"
      @hidden="onModalHidden"
    >

     <div class="position-relative w-100 h-100">
        <!-- Nút X trong ảnh -->
        <button
          class="btn position-absolute"
          style="top: 10px; right: 10px; z-index: 1050; border-radius: 50%; padding: 0.2rem 0.5rem; font-weight: 900;"
          @click="show = false"
        >
          ✕
        </button>
        <b-carousel
          v-model="slide"
          :no-touch="false"
          :interval="3000"
          :controls="false"
          indicators
          fade
          :key="slideMobileKey"
          style="background: transparent; border: none; box-shadow: none;"
        >
          <b-carousel-slide v-for="(item, index) in items" :key="index">
            <template #img>
              <img
                :class="item.class || imgClass"
                :width="item.width || imgWidth"
                :height="item.height || imgHeight"
                style="object-fit: contain;"
                :src="item.img"
                :alt="`slide-${index}`"
              >
            </template>
          </b-carousel-slide>
        </b-carousel>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'AppCarousel',
  props: {
    imgWidth: {
      type: [Number, String],
      default: 680,
    },
    imgHeight: {
      type: [Number, String],
      default: 480,
    },
    imgClass: {
      type: String,
      default: 'd-block img-fluid w-100'
    },
    interval: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slide: 0,
      // slideMobile: 0,
      show: false, // status of popup
      slideMobileKey: 0,
      popupShown: false,
    }
  },
  // computed: {
  //   mobileItems() {
  //     return this.items.filter(item => item.imgMobile);
  //   }
  // },
  mounted() {
    this.handleRouteChange(this.$route)
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    this.resetScroll();
  },
  watch: {
    $route(to) {
      this.handleRouteChange(to)
    },
    show(val) {
      if (val) {
        document.body.style.overflow = "hidden";
        window.addEventListener("touchmove", this.preventScroll, { passive: false });
      } else {
        this.resetScroll();
      }
    }
  },
  methods: {
    handleRouteChange(to) {
      if (to.name === 'register' && window.innerWidth <= 767) {
        this.show = true
        this.popupShown = true
      } else {
        this.show = false
        this.popupShown = false
        this.resetScroll()
      }
    },
    handleResize() {
      if (window.innerWidth >= 767) {
        this.show = false;
        this.resetScroll()
      }
    },
    onModalHidden() {
      this.show=false
      this.popupShown = false
      this.resetScroll()
    },
      preventScroll(e) {
      e.preventDefault();
    },
    resetScroll() {
      document.body.style.overflow = ""
      window.removeEventListener("touchmove", this.preventScroll)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-carousel/index.vue